module.exports = __webpack_public_path__ + "static/media/beaumonde-1.a804cf46.webp";